module.exports = __webpack_public_path__ + "img/shrugs-shoulders.5516bef4.png";